import * as R from "ramda";

import React from "react";

import { indexedColors } from "components/Base/Base/colorSpecs";

import { FontIcon } from "components/Base";

import { noop } from "utils/General";

const StatusCircle = ({ status, size = 26, onClick = noop }) => (
  <div
    style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
    onClick={onClick}
  >
    {R.propOr(
      <FontIcon
        from="material-symbols-outlined"
        style={{ fontSize: size, color: indexedColors.success7 }}
        color={{
          default: indexedColors.success7,
          hover: indexedColors.success7
        }}
      >
        task_alt
      </FontIcon>,
      status,
      {
        task_not_complete: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.orange6,
              hover: indexedColors.orange6
            }}
          >
            fact_check
          </FontIcon>
        ),
        task_complete: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.success8,
              hover: indexedColors.success9
            }}
          >
            task_alt
          </FontIcon>
        ),
        approved: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.success8,
              hover: indexedColors.success9
            }}
          >
            task_alt
          </FontIcon>
        ),

        "not-submitted": (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.orange5,
              hover: "#FFC58E"
            }}
          >
            fact_check
          </FontIcon>
        ),
        "manual-not-submitted": (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.orange5,
              hover: indexedColors.orange6
            }}
          >
            fact_check
          </FontIcon>
        ),
        pending: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.yellow5,
              hover: indexedColors.yellow6
            }}
          >
            pending_actions
          </FontIcon>
        ),
        rejected: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.danger4,
              hover: indexedColors.danger5
            }}
          >
            cancel
          </FontIcon>
        ),
        default: (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.neutral2,
              hover: "#BDBDBD"
            }}
          >
            add_circle
          </FontIcon>
        ),
        "not-assigned": (
          <FontIcon
            from="material-symbols-outlined"
            style={{ fontSize: size }}
            color={{
              default: indexedColors.neutral2,
              hover: "#BDBDBD"
            }}
          >
            add_circle
          </FontIcon>
        )
      }
    )}
  </div>
);

export default StatusCircle;
